import _MpSector from "./MpSector.jsx"
import withInstall from "../../utils/withInstall"

export const MpSector = withInstall(_MpSector)
export default MpSector
